import Vue from "vue";
import store from "@/vuex";
import configs from "@/config/config.js";
import require from "./require";
const state = () => ({
  balance: 0,
  gold: 0,
  coinenergy: 0
});

const mutations = {
  setBalance(state, balance) {
    state.balance = balance;
  },
  setgold(state, gold) {
    state.gold = gold;
  },
  setenergy(state, coinenergy) {
    state.coinenergy = coinenergy;
  },
};
const actions = {

  // 获取订单列表
  async GetWareList({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/GetWareList`, {
      ...postData
    })
    console.log('GetWareList', res)
    return res.data
  },

  // 获取砖石余额
  async Coin({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/Coin`, {
      ...postData
    })

    if (res.data.stateCode == 1) {
      commit("setBalance", res.data.resultInfo.data);
      commit("setgold", res.data.resultInfo.values.gold);
      commit("setenergy", res.data.resultInfo.values.energy);

    }

    console.log('Coin', res)
    return res.data
  },


  // 获取兑换比例
  async getCoinPrice({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/CoinPrice`, {
      ...postData
    })
    console.log('CoinPrice', res)
    if (res.data.stateCode == 1) {
      return {
        diamondPrice: res.data.resultInfo.data.cost.value,
        goldPrice: res.data.resultInfo.data.target.value
      }
    }
    return false
  },


  // 钻石兑换金币
  async getCoinChange({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/CoinChange`, {
      ...postData
    })
    console.log('CoinChange', res)
    return res.data
  },


  // 创建订单
  async OrderCreate({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/OrderCreate`, {
      ...postData
    })
    console.log('OrderCreate', res)
    return res.data
  },

  // 创建支付单
  async PayCreate({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/PayCreate`, {
      ...postData
    })
    console.log('PayCreate', res)
    return res.data
  },

  // 订单轮询
  async OrderState({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/OrderState`, {
      ...postData
    })
    console.log('OrderState', res)
    return res.data
  },

  // 关闭订单
  async OrderClose({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem('Bearer') || '', 'Bearer')
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/OrderClose`, {
      ...postData
    })
    console.log('OrderClose', res)
    return res.data
  },

  // 获取账单列表
  async CoinList({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/CoinList`, {
      ...postData
    })
    console.log('CoinList', res)
    return res.data
  },

  // 获取支付类型
  async PayType({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.mypost($axios, `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/PayType`, {
      ...postData
    })
    console.log('PayType', res)
    return res.data
  },

  // 轮询  khalasPay接口
  async khalasPayCheck({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget($axios, `${tgaPlatformSDK.data.apiBaseHost}/khalasPay/payCheckOrFinish`, {
      ...postData
    })
    console.log('khalasPayCheck', res)
    return res.data
  }



}

export default {
  namespaced: true,
  state,
  mutations,
  actions

}



// WEBPACK FOOTER //
// ./src/vuex/modules/pay.js